import type { GetArtistPageTalksQuery } from '#lib/websites/artists/queries/__generated__/getArtistPageTalks.generated.js';

export const transformInfiniteDataTalks = (data: GetArtistPageTalksQuery) => {
	const artistTalks =
		data.Artists[0]?.talks?.map((talk) => talk?.HENI_Talks_Talks_id) || [];

	return artistTalks;
};
